import { reactive, ref } from "vue"

import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign"
import { CampaignListConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel"
import { CampaignListFilterConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel"

export const useCampaignList = function (configList) {
    const isLoading = ref(false)
    const items = ref([])
    const timerId = ref(null)

    const builders = reactive({
        config: new CampaignListConfigBuilder(),
        filter: new CampaignListFilterConfigBuilder()
    })

    const events = reactive({
        onLoading: () => true,
        onLoaded: () => true,
        onSuccess: () => true,
        onError: () => true,
    })

    const resetConfig = function () {
        items.value = []
        builders.config.setSkip(0)
        builders.config.setSeeMore(true)
    }

    const setConfig = function (str) {
        resetConfig()
        // builders.config.setTop(20)
        builders.config.setConfigList(str)
    }

    const setSearch = function (q) {
        resetConfig()
        builders.filter.setSearch(q)
    }

    const getList = function () {
        isLoading.value = true
        events.onLoading()

        BzbsCampaign.apiGetCampaign(builders.config.create(), builders.filter.create()).subscribe({
            next: data => {
                isLoading.value = false

                if (data.length > 0) {
                    builders.config.nextSkip()
                    items.value = items.value.concat(data)
                }

                if (data.length < builders.config.getTop()) {
                    builders.config.setSeeMore(false)
                }

                events.onLoaded()
                events.onSuccess()
            },
            error: (err) => {
                isLoading.value = false
                events.onLoaded()
                events.onError(err)
            }
        })
    }

    const loadMore = function () {
        // distinct load more events
        console.log(isLoading.value, builders.config.canLoadMore());
        if (isLoading.value || !builders.config.canLoadMore()) return

        clearTimeout(timerId.value)
        timerId.value = setTimeout(() => {
            getList()
        }, 250);
    }

    setConfig(configList)

    return {
        items,
        builders,
        events,
        getList,
        loadMore,
        setConfig,
        setSearch,
        resetConfig
    }
}

export default useCampaignList
